import React from 'react';
import PropTypes from 'prop-types';
import Navbar from 'reactstrap/lib/Navbar';

export const XL_BREAKPOINT = 1200;

// Navigation for tablets, laptops and desktop

export function GlobalNavigationDesktop({ children = null }) {
  return (
    <Navbar
      className="global-navigation-desktop d-flex flex-wrap flex-sm-nowrap flex-row align-items-center justify-content-between"
      aria-label="Main Navigation"
    >
      {children}
    </Navbar>
  );
}

GlobalNavigationDesktop.propTypes = {
  children: PropTypes.node,
};
